import { CartProductsSchema } from 'src/models/cart/CartProductsSchema';
import { Product } from 'src/models/product/schema';
import { LOCALE_TYPE } from 'src/types/locale';

type UpdatedCartObject = {
  productId: number;
  quantity: number;
  productName: string;
  price: number;
  productImgUrl: string;
};

export const pushCartUpdateToDataLayer = (
  cart: CartProductsSchema[],
  updatedProduct: Product,
  updatedQuantity: number,
  locale: LOCALE_TYPE,
  fromNotCartPage: boolean = false,
) => {
  if (locale === LOCALE_TYPE.CN) return;

  const calculateQuantity = (
    productInCart: CartProductsSchema,
    updatedProduct: Product,
    updatedQuantity: number,
    fromNotCartPage: boolean,
  ) => {
    if (productInCart.productId !== updatedProduct.productId) return productInCart.quantity;
    const newQuantity = fromNotCartPage ? productInCart.quantity + updatedQuantity : updatedQuantity;
    return newQuantity > 0 ? newQuantity : 0;
  };

  const updatedCart = cart.reduce((acc: UpdatedCartObject[], productInCart: CartProductsSchema) => {
    const newQuantity = calculateQuantity(productInCart, updatedProduct, updatedQuantity, fromNotCartPage);
    // if newQuantity is 0, remove the product from the cart
    if (newQuantity > 0 || productInCart.productId !== updatedProduct.productId) {
      acc.push({
        productId: productInCart.productId,
        quantity: newQuantity,
        productName: productInCart.name,
        price: productInCart.undiscountedPrice,
        productImgUrl: productInCart.images[0],
      });
    }
    return acc;
  }, []);

  const isProductInCart = cart.some((productInCart) => productInCart.productId === updatedProduct.productId);
  if (!isProductInCart) {
    updatedCart.push({
      productId: updatedProduct.productId,
      quantity: updatedQuantity,
      productName: updatedProduct.name,
      price: updatedProduct.undiscountedPrice,
      productImgUrl: updatedProduct.images[0],
    });
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ updated_cart: null });
  window.dataLayer.push({
    event: 'cart_update',
    updated_cart: updatedCart,
  });
};
